<template>
    <div class="kgk-password-forgotten">
        <h2 v-if="!insideModal">
            Passwort zurücksetzen
        </h2>
        <form @submit.prevent="performReset">
            <div class="kgk-form-row">
                Dein neues Passwort
                <div class="kgk-input-group">
                    <input type="password" v-model="form.password" :disabled="retryResetRequest">
                </div>
                <div v-if="showValidationErrors && !passwordLengthValidation" class="kgk-form-validation-error-inline">Passwort muss mindestens 8 Zeichen haben.</div>
            </div>
            <div class="kgk-form-row">
                Passwort bestätigen
                <div class="kgk-input-group">
                    <input type="password" v-model="passwordConfirm" :disabled="retryResetRequest">
                </div>
                <div v-if="!passwordEqualityValidation" class="kgk-form-validation-error-inline">Passwörter stimmen nicht überein</div>
            </div>
            <div v-if="!insideModal" class="kgk-form-row">
                <button type="submit" :disabled="retryResetRequest">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span class="button-text">Passwort zurücksetzen</span>
                </button>
            </div>

            <div v-if="retryResetRequest">
                <div class="spacer-small"></div>
                <PasswordForgotten :mode="'retry-reset'" />
            </div>
            <!--<p>
                Blub Blub / Reset code: {{ resetCode }}
            </p>-->
        </form>
    </div>
</template>

<script>
    import registration from '../../api/registration';
    import router from '../../router';

    import PasswordForgotten from './PasswordForgotten';

    export default {
        name: 'PasswordResetForm',
        components: {
            PasswordForgotten,
        },
        props: {
            resetCode: {
                type: String,
                required: true
            },
            insideModal: {
                type: Boolean,
                //required: true,
                default: false,
            },
            /*modalSaveTrigger: {
                type: Object,
                required: false
            },*/
        },
        data() {
            return {
                loading: false,
                form: {
                    password: '',
                },
                passwordConfirm: '',
                showValidationErrors: false,
                retryResetRequest: false,
                error: '',
            }
        },
        computed: {
            passwordLengthValidation() {
                return this.form.password.length >= 8;
            },
            passwordEqualityValidation() {
                if( this.form.password.length == 0 || this.passwordConfirm.length == 0 ) {
                    return true;
                }

                return this.form.password === this.passwordConfirm;
            }
        },
        methods: {
            performReset(/*calledFromModal*/) {
                //calledFromModal = calledFromModal || false;

                if( this.loading ) {
                    return;
                }

                this.showValidationErrors = true;

                if( !this.passwordLengthValidation
                    || !this.passwordEqualityValidation) {
                    this.$notify({
                        type: 'warn',
                        title: 'Eingaben fehlerhaft.',
                        text: 'Bitte korrigiere deine Formulareingaben.'
                    });

                    return;
                }

                this.loading = true;

                registration.resetPassword(
                    this,
                    this.resetCode,
                    this.form.password,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Passwort zurückgesetzt',
                            text: 'Dein Passwort wurde erfolgreich geändert. Du kannst dich nun damit anmelden.'
                        });

                        router.push('/login');
                    },
                    e => {
                        //console.error(e.response.status);

                        if( e.response.status == 404 ) {
                            this.retryResetRequest = true;
                        }

                        if( e.response.status == 400 || typeof e.response.data.message !== 'undefined' ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => this.loading = false
                );
            },

        },
        watch: {
            'modalSaveTrigger.trigger'() {
                this.requestReset();
            },
            $route(/*to, from*/) {
                this.form.password = '';
                this.passwordConfirm = '',

                this.showValidationErrors = false;
                this.retryResetRequest = false;
            }
        },
        mounted() {

        }
    }
</script>

